import { render } from "./CreateCompte.vue?vue&type=template&id=115599ab&scoped=true"
import script from "./CreateCompte.vue?vue&type=script&lang=js"
export * from "./CreateCompte.vue?vue&type=script&lang=js"

import "./CreateCompte.vue?vue&type=style&index=0&id=115599ab&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\Vuejsproject\\final\\yajobici-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115599ab"]])

export default __exports__